<i18n locale="en">
{
  "title": "Set as Primary",
  "message": "Set this image as the primary image for {itemName}?",
  "cancel": "Cancel",
  "confirm": "Set as Primary"
}
</i18n>

<template>
  <OwnDialog v-model="isVisible" @cancel="closeDialog">
    <template #heading>
      <OwnDialogHeading :title="t('title')" @cancel="closeDialog" />
    </template>
    <template #default>
      <OwnDialogContent scroll>
        <OwnType :text="t('message', { itemName })" />
      </OwnDialogContent>
    </template>
    <template #footer>
      <OwnDialogFooter>
        <OwnButton :text="t('cancel')" @click="closeDialog" />
        <OwnButton
          :text="t('confirm')"
          variant="primary"
          :processing="processing"
          @click="onConfirm"
        />
      </OwnDialogFooter>
    </template>
  </OwnDialog>
</template>

<script lang="ts" setup>
import { useI18n } from 'vue-i18n'

import { OwnButton } from '@/ui/OwnButton'
import {
  OwnDialog,
  OwnDialogContent,
  OwnDialogFooter,
  OwnDialogHeading,
} from '@/ui/OwnDialog'
import { OwnType } from '@/ui/OwnType'

defineProps<{
  itemName: string
  processing: boolean
}>()

const emit = defineEmits<{
  (e: 'confirm'): void
  (e: 'cancel'): void
}>()

const { t } = useI18n()

const isVisible = defineModel<boolean>({ required: true })

const closeDialog = () => {
  emit('cancel')
  isVisible.value = false
}

const onConfirm = () => {
  emit('confirm')
}
</script>
